import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import CommonToast from "../../../_utils/CommonToast";
import CardContainer from "../../../_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import { formatAccountNumber } from "../../../_utils/FormatAccountNumber";
import IfscCodeMapper from "../../../_utils/IfscLogoMapper";
import TickerAnimation from "../../../_utils/TickerAnimation";
import "./index.css";

const BeneAccountGridView = ({
  id,
  data,
  isSidebarOpen,
  type,
  typepop,
  handleButtonClick,
  internalAccount,
  associateAccount,
  setOpenBeneAssociate,
  showSearchBar,
  txnPayLoad,
  accountType,
  associateTxn,
  name1,
  scheduleIntenralTxn,
  isLabelClicked,
  setLabelAccounts,
  LabelAccounts,
  setlableInput,
  Labeldata,
  setLabeldata,
  filterRef,
  subType,
  beneAccountId,
  onCardNavigate,
  setIsalertPopup,
  setFlowSelectedId,
  classifiedFlow,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "rejected":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--awaiting)";
    }
  };

  useEffect(() => {
    displayedDAata();
  }, [associateAccount, associateTxn]);

  const displayedDAata = () => {
    // setmapData(
    //   data.filter((item) => {
    //     item.id !== id;
    //   }),
    // );
    // if (associateAccount && accountType !== "internal") {
    //   if (balanceType === "Pan") {
    //     setmapData(
    //       data.filter((item) => item.bank_acc_no !== associateaccountNumber),
    //     );
    //   }
    //   if (balanceType === "Bank") {
    //     setmapData(data.filter((item) => item.pan_no !== associatepanNumber));
    //   }
    // } else if (associateAccount && accountType === "internal") {
    //   setmapData(
    //     data.filter((item) => item.bank_acc_no !== associateaccountNumber),
    //   );
    // } else if (associateTxn === "associateTxn") {
    //   setmapData(
    //     data.filter((item) => {
    //       return item.bank_acc_no !== associateaccountNumber;
    //     }),
    //   );
    // }
  };

  return (
    <>
      <div
        style={{
          overflowY: isSidebarOpen ? "hidden" : "",
          zIndex: typepop === "popup" && "var(--z-index-content)",
          // display:
          //   data?.filter((item) => item.id !== beneAccountId).length ===
          //   GlobalConfiguration.lengthCheckZero
          //     ? "flex"
          //     : "grid",
        }}
        className={`standard-card-alignment gap-x-gap-sm gap-y-gap-md ${
          isSidebarOpen ? "sidebar-open" : ""
        }
    ${
      data?.filter((item) => item.id !== beneAccountId).length ===
        GlobalConfiguration.lengthCheckZero && "flex-1"
    }`}
      >
        {data?.length > GlobalConfiguration.lengthCheckZero ? (
          data?.map((account, index) => {
            const redirectUrl =
              internalAccount === "internalAccount" ||
              accountType === "internal"
                ? `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${account.id}`
                : `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${account.id}`;
            return (
              <CardContainer
                key={account.id}
                hoverHeight={GlobalConfiguration.beneAccountCardHoverHeight}
                filterRef={filterRef}
                minHeight={GlobalConfiguration.BeneAccCardMinHeight}
                context={account}
                isSelected={
                  Array.isArray(LabelAccounts) &&
                  LabelAccounts.includes(account.id)
                }
                isDisabled={
                  account.id == id ||
                  (isLabelClicked && account?.approval_status === "archived") ||
                  (!(
                    associateAccount ||
                    (associateTxn === "associateTxn" &&
                      (account?.approval_status === "blocked" ||
                        account?.approval_status === "archived" ||
                        account?.approval_status === "rejected"))
                  ) &&
                    typepop === "popup" &&
                    (account?.approval_status === "blocked" ||
                      account?.approval_status === "archived" ||
                      account?.approval_status === "rejected")) ||
                  (typepop === "popup" &&
                    account?.approval_status !== "blocked" &&
                    account?.approval_status !== "archived" &&
                    account?.approval_status !== "rejected" &&
                    internalAccount === "internalAccount" &&
                    txnPayLoad?.ownerBankAccountNo === account?.bank_acc_no &&
                    txnPayLoad?.ownerBankIFSC === account?.ifsc_code &&
                    txnPayLoad?.ownerPan === account?.pan_no)
                }
                onClickHandler={(e) => {
                  if (classifiedFlow) {
                    navigate(
                      `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${account.id}`,
                      {
                        replace: true,
                      },
                    );
                    return;
                  }
                  if (type === "activeInactive") {
                    setIsalertPopup(true);
                    setFlowSelectedId(account?.id);
                    return;
                  }
                  if (associateAccount && subType === "reimbursement") return;
                  if (onCardNavigate) {
                    onCardNavigate(redirectUrl);
                    return;
                  }
                  if (name1 !== "alerAssoc") {
                    if (
                      typepop === "popup" &&
                      scheduleIntenralTxn &&
                      (account?.approval_status === "blocked" ||
                        account?.approval_status === "archived" ||
                        account?.approval_status === "rejected" ||
                        (txnPayLoad?.ownerBankAccountNo ===
                          account?.bank_acc_no &&
                          txnPayLoad?.ownerBankIFSC === account?.ifsc_code &&
                          txnPayLoad?.ownerPan === account?.pan_no))
                    ) {
                      CommonToast({
                        text: "Destination account cannot be same as source account.",
                        icon: ICONS?.ERROR_WHITE_CIRCLE,
                        variant: "var(--error)",
                        buttonNeeded: false,
                      });
                      return;
                    } else if (
                      typepop === "popup" &&
                      (account?.approval_status === "blocked" ||
                        account?.approval_status === "archived" ||
                        account?.approval_status === "rejected") &&
                      !associateAccount
                    ) {
                      if (isLabelClicked) {
                        if (LabelAccounts.includes(account.id)) {
                          setLabelAccounts(
                            LabelAccounts.filter((id) => id !== account.id),
                          );
                        } else {
                          setLabelAccounts([...LabelAccounts, account.id]);
                          setLabeldata([...Labeldata, account]);
                        }
                        setlableInput(false);
                      } else {
                        return;
                      }
                    } else if (typepop === "popup" && !associateAccount) {
                      if (isLabelClicked) {
                        if (LabelAccounts.includes(account.id)) {
                          setLabelAccounts(
                            LabelAccounts.filter((id) => id !== account.id),
                          );
                        } else {
                          setLabelAccounts([...LabelAccounts, account.id]);
                          setLabeldata([...Labeldata, account]);
                        }
                        setlableInput(false);
                      } else {
                        if (e && e.stopPropagation) {
                          e.stopPropagation();
                        }
                        handleButtonClick(account);
                      }
                    } else if (!isSidebarOpen) {
                      const redirectUrl =
                        internalAccount === "internalAccount" ||
                        accountType === "internal"
                          ? `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${account.id}`
                          : `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${account.id}`;
                      if (
                        (accountType === "internal" ||
                          accountType === "beneficiary") &&
                        !isLabelClicked
                      ) {
                        if (type !== "viewOnlyCards") {
                          if (onCardNavigate) {
                            onCardNavigate(redirectUrl);
                            return;
                          } else {
                            navigate(redirectUrl, {
                              replace: true,
                              state: {
                                isViewAll:
                                  internalAccount === "internalAccount" ||
                                  accountType === "internal"
                                    ? location.pathname ===
                                      "/internal_account_dashboard/internal_account_view_all"
                                    : location.pathname ===
                                      "/beneficiary_account_dashboard/beneficiary_account_view_all",
                              },
                            });
                          }

                          if (LabelAccounts?.includes(account.id)) {
                            setLabelAccounts(
                              LabelAccounts.filter((id) => id !== account.id),
                            );
                          } else {
                            setLabelAccounts([...LabelAccounts, account.id]);
                            setLabeldata([...Labeldata, account]);
                          }
                        }

                        if (isLabelClicked) {
                          setOpenBeneAssociate(true);
                        } else {
                          setOpenBeneAssociate(false);
                        }
                        setlableInput(false);
                      } else {
                        if (!isLabelClicked) {
                          if (onCardNavigate) {
                            onCardNavigate(redirectUrl);
                            return;
                          } else {
                            navigate(redirectUrl, {
                              state: {
                                isViewAll:
                                  internalAccount === "internalAccount" ||
                                  accountType === "internal"
                                    ? location.pathname ===
                                      "/internal_account_dashboard/internal_account_view_all"
                                    : location.pathname ===
                                      "/beneficiary_account_dashboard/beneficiary_account_view_all",
                              },
                            });
                          }
                        } else {
                          if (LabelAccounts?.includes(account.id)) {
                            setLabelAccounts(
                              LabelAccounts.filter((id) => id !== account.id),
                            );
                          } else {
                            setLabelAccounts([...LabelAccounts, account.id]);
                            setLabeldata([...Labeldata, account]);
                          }
                          setlableInput(false);
                        }
                      }
                    }
                  }
                }}
              >
                <card-body>
                  <TextWithIcon
                    type={"text"}
                    text={account.name
                      .toLowerCase()
                      .split(" ")
                      .map(
                        (word) => word.charAt(0).toUpperCase() + word.slice(1),
                      )
                      .join(" ")}
                    textColor={"var(--text-primary)"}
                    subText={"Account name"}
                    iconComponentArray={[
                      ...(internalAccount === "internalAccount" ||
                      (associateAccount && accountType === "internal")
                        ? [
                            {
                              icon: ICONS.INTERNAL_WHITE_CIRCLE_WITHOUT_FILL,
                              isDisabled: false,
                            },
                          ]
                        : []),
                      ...(isLabelClicked
                        ? [
                            {
                              icon:
                                Array.isArray(LabelAccounts) &&
                                LabelAccounts.includes(account.id)
                                  ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                                  : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg",
                              isDisabled: false,
                            },
                          ]
                        : []),
                    ]}
                  />

                  <div className="flex gap-x-gap-sm justify-between items-center">
                    <div className="flex flex-1 truncate flex-col gap-y-gap-xs">
                      <p className="text-font-sm text-text-primary flex-1 truncate font-normal pl-padding-sm">
                        <TickerAnimation
                          text={formatAccountNumber(account.bank_acc_no)}
                        />
                      </p>

                      <div className="w-full relative flex pl-padding-sm justify-between items-center">
                        <p className="text-font-xs text-text-secondary flex-1 truncate font-normal">
                          Account number
                        </p>
                      </div>
                    </div>

                    <div className="bg-text-primary flex items-center gap-x-gap-sm rounded-l-border-radius-md py-padding-xs px-padding-sm">
                      <div className="w-banklogo-width-sm h-icon-xs flex-shrink-0">
                        <IfscCodeMapper ifscCode={account?.ifsc_code} />
                      </div>
                    </div>
                  </div>
                </card-body>

                <card-hover>
                  <TextWithIcon
                    text={account?.approval_status}
                    subText={"Account status"}
                    textCase={"capitalize"}
                    fontWeight={"semibold"}
                    textColor={getStatusColor(account?.approval_status)}
                  />

                  <TextWithIcon
                    text={account?.labels?.join(", ") || "No labels assigned"}
                    iconComponentArray={[
                      {
                        icon: "https://q2pay.in/new_assets/common/view_all/label.svg",
                      },
                    ]}
                    fontWeight={"normal"}
                    textColor={"var(--text-primary)"}
                  />
                </card-hover>
              </CardContainer>
            );
          })
        ) : (
          <div
            className="flex flex-col items-center justify-center m-auto w-full h-full"
            style={{
              height:
                typepop === "popup" && !showSearchBar
                  ? "h-full-height Qsmd:h-height-full"
                  : typepop === "popup" && showSearchBar
                    ? "var(--height-full)"
                    : "",
              overflowY: "scroll",
              scrollbarWidth: "none",
            }}
          >
            <img
              src="https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
              alt="No accounts found"
              className={` opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm`}
            />
            <p className="bene-acc-no-beneaccount-text">No accounts found.</p>
          </div>
        )}
      </div>
    </>
  );
};

export default BeneAccountGridView;
